// Utilidades comunes para usar con fullcalendar
import { dateToTimeString } from '../dates';
import { dasherize } from '../strings';

// Renderiza parámetros especiales nuestros que le podemos pasa como por ejemplo
// un icono, subtítulo, tooltip etc.
/* eslint import/prefer-default-export:0 */
export function renderExtraData(fullcalendarInfo, options = {}) {
  const { event, el } = fullcalendarInfo;
  const extra = event.extendedProps;
  const icon = options.icon || extra.icon;
  const subtitle = options.subtitle || extra.subtitle;
  const tooltip = options.tooltip || extra.tooltip;
  if (icon) {
    const titleDom = el.querySelector('.fc-event-title, .fc-list-event-title');
    titleDom.insertAdjacentHTML('afterbegin', `<i class="fa fa-${dasherize(icon)}"></i>`);
  }
  if (subtitle) {
    const container = el.querySelector('.fc-event-title-container');
    if (container) {
      container.insertAdjacentHTML('beforeend', `<div>${subtitle}</div>`);
    }
  }
  if (tooltip) {
    let content = tooltip;
    // Si es true, generamos el contenido por defecto
    if (tooltip === true) {
      content = `<div>${event.title}</div>`;
      if (subtitle) {
        content += `<div>${subtitle}</div>`;
      }
    }
    if (!event.allDay) {
      content += `<div>${dateToTimeString(event.start)} - ${dateToTimeString(event.end)}</div>`;
    }
    el.setAttribute('data-toggle', 'tooltip');
    el.setAttribute('data-html', 'true');
    el.setAttribute('data-title', content);
  }
}
